import { defineMessages } from "react-intl";
import { node as encephalopathy } from "src/modules/ltx/forms/phase-i/medical-history/liver-related-complications/encephalopathy";
import { node as hepatorenalSyndrome } from "src/modules/ltx/forms/phase-i/medical-history/liver-related-complications/hepatorenalSyndrome";
import { node as varicealBleeding } from "src/modules/ltx/forms/phase-i/medical-history/liver-related-complications/varicealBleeding";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.liver_related_complications",
		defaultMessage: "Hepatológiai szövődmények"
	}
});

export const node: ParentNode = {
	id: "liverRelatedComplications",
	value: { type: "wizard", title: messages.title },
	children: [encephalopathy, hepatorenalSyndrome, varicealBleeding]
};
